import { prefix, ajax } from './common';

export async function getDiagramsForEquipment(id: number) {
  return await ajax({
    url: prefix + '/equipment/' + id + '/diagrams'
  });
}

export async function getDiagramParts(id: number) {
  return await ajax({
    url: prefix + '/diagrams/' + id + '/parts'
  });
}

export async function getDiagramNotes(id: number) {
  return await ajax({
    url: prefix + '/diagrams/' + id + '/notes'
  });
}

export async function addDiagramNote(id: number, text: string) {
  return await ajax({
    method: 'POST',
    url: prefix + '/diagrams/' + id + '/notes',
    data: {
      text
    }
  });
}